// extracted by mini-css-extract-plugin
module.exports = {"rootCollapse":"styles_rootCollapse___TKs7","collapsed":"styles_collapsed__9WXo0","collapseChildrenContainer":"styles_collapseChildrenContainer__JtiFl"};